import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { configureActions } from '../../../../../actions/configure.action';
import sensorsActions from '../../../../../actions/sensors.actions';
import helper from '../../../../../utils/helper';
import MaintainDBPage from './MaintainDBPage';

class MaintainDB extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      group: {},
      getGroupError: {},
      assignedSensors: [],
      unassignedSensors: [],
      errors: '',
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.sensors.assignedSensors !== prevState.assignedSensors) {
      state.assignedSensors = nextProps.sensors.assignedSensors;
    }
    if (nextProps.sensors.unassignedSensors !== prevState.unassignedSensors) {
      state.unassignedSensors = nextProps.sensors.unassignedSensors;
    }
    if (nextProps.configure.group !== prevState.group) {
      state.group = nextProps.configure.group;
    }
    if (nextProps.configure.getGroupError !== prevState.getGroupError) {
      state.getGroupError = nextProps.configure.getGroupError;
    }
    state.errors = helper.centralizeError([nextProps.sensors.errors]);
    return Object.keys(state).length ? state : null;
  }
  fetchLists = async () => {
    const { groupId } = this.props.match.params;
    await this.props.sensorsActions.getAssignedSensors(groupId);
    await this.props.sensorsActions.getUnassignedSensors();
  };
  async componentDidMount() {
    const { groupId } = this.props.match.params;
    await this.props.configureActions
      .getSpecificGroup(groupId)
      .finally(() => this.fetchLists());
  }
  onAssign = (sensorIds) => {
    const { groupId } = this.props.match.params;
    this.props.sensorsActions
      .assignSensors(groupId, sensorIds)
      .then(() => this.fetchLists());
  };
  onReplace = (existingSensorId, unassignedSensorId) => {
    this.props.sensorsActions
      .replaceSensor(existingSensorId[0], unassignedSensorId[0])
      .then(() => this.fetchLists());
  };
  onUnassign = (sensorIds) => {
    this.props.sensorsActions
      .unassignSensors(sensorIds)
      .then(() => this.fetchLists());
  };
  onDelete = (sensorIds) => {
    this.props.sensorsActions
      .deleteUnassignedSensors(sensorIds)
      .then(() => this.fetchLists());
  };
  onRepurpose = (sensorIds) => {
    this.props.sensorsActions
      .repurposeSensors(sensorIds)
      .then(() => this.fetchLists())
      .catch((err) => this.setState({ errors: err }));
  };
  onUpdateActive = (sensorId, active) => {
    this.props.sensorsActions
      .updateActiveSensor(sensorId, active)
      .then(() => this.fetchLists());
  };
  onUpdateAlerts = (sensorId, active) => {
    this.props.sensorsActions
      .updateAlertsSensor(sensorId, active)
      .then(() => this.fetchLists());
  };
  render() {
    return (
      <MaintainDBPage
        {...this.state}
        {...this.props}
        onAssign={this.onAssign}
        onReplace={this.onReplace}
        onUnassign={this.onUnassign}
        onDelete={this.onDelete}
        onRepurpose={this.onRepurpose}
        onUpdateActive={this.onUpdateActive}
        onUpdateAlerts={this.onUpdateAlerts}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    sensors: state.sensors,
    configure: state.configure,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    sensorsActions: bindActionCreators(
      Object.assign({}, sensorsActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MaintainDB);
